<div class="lateral-nav sidebar">
    <div #navIcon id="nav-icon" (click)="toggle()">
        <span></span>
        <span></span>
        <span></span>
        <span>
            <img src="./assets/img/Logo horizontal_ENG_white.png" class="user-avatar logo" />
        </span>
    </div>
    <div id="nav" class="collapsed" #sidebar>
        <div class="global-div">
            <div matTooltip="{{'Menu.Home' | translate}}" class="inner-div" (click)="home()" matTooltipPosition="right">
                <span class="nav-button">
                    <mat-icon style="color: white;">home</mat-icon>
                </span>
                <span class="text">{{'Menu.Home' | translate}}</span>
            </div>
        </div>
        <label *ngIf="adminMenu.length > 0">Admin</label> <span>Adm.</span>
        <div *ngFor="let menu of adminMenu" class="global-div">
            <div matTooltip="{{menu.name}}" class="inner-div" (click)="goToMenu(menu)" matTooltipPosition="right">
                <span class="nav-button">
                    <img [src]="getImg(menu.icon)" />
                </span>
                <span class="text">{{'Menu.' + menu.name | translate}}</span>
            </div>
        </div>
        <label *ngIf="certsMenu.length > 0">Certs</label><span>Crt.</span>
        <div *ngFor="let menu of certsMenu" class="global-div">
            <div matTooltip="{{menu.name}}" class="inner-div" (click)="goToMenu(menu)" matTooltipPosition="right">
                <span class="nav-button">
                    <img [src]="getImg(menu.icon)" />
                </span>
                <span class="text">{{'Menu.' + menu.name | translate}}</span>
            </div>
        </div>
        <div class="global-div profile">
            <div matTooltip="Profile" class="inner-div" (click)="userProfile()" matTooltipPosition="right">
                <span class="nav-button">
                    <mat-icon style="color: white;">account_circle</mat-icon>
                </span>
                <span class="text">{{name}} <br> {{ lastAccess }}</span>
            </div>
        </div>
        <div class="global-div logout">
            <div matTooltip="LogOut" class="inner-div" (click)="logOut()" matTooltipPosition="right">
                <span class="nav-button">
                    <mat-icon style="color: white;">power_settings_new</mat-icon>
                </span>
                <span class="text">{{'Menu.Log out' | translate}}</span>
            </div>
        </div>
    </div>
</div>